import { Card, styled } from '../../base';

export const StyledJobPageWrap = styled('div')<{ showTable: boolean }>(
    ({ showTable }) => ({
        display: showTable ? 'inherit' : 'none',
        padding: '16px',
    })
);

export const StyledTableContainer = styled(Card)(({ theme }) => ({
    padding: theme.spacing(1),
}));
